import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

import Price from 'Containers/Utility/Price/Price';
import { currencyCode } from 'Helpers/Geo/data';

import 'Components/Product/ProductCommerce/ProductEditionSelector.scss';

function ProductEditionSelector({ product, sortByName }) {
  if (!product || !product.editions || !product.editions.length || product.editions.length === 1) {
    return false;
  }

  let editions = product.editions;

  if (sortByName) {
    editions = orderBy(editions, e => e.name.replace(/[0-9]+/, ''), 'asc');
  }

  const presale = get(product, 'presale', false);

  return (
    <div
      className={classNames(
        'product-edition-selector',
        { 'two-editions': editions.length === 2 },
        { 'three-editions': editions.length === 3 },
        { 'four-editions': editions.length === 4 },
      )}
    >
      {editions.map((edition) => {
        const currentPrice = edition.currentPrice;
        const editionName = get(edition, 'edition_name', edition.name).replace(' Edition', '');

        return (
          <React.Fragment key={edition.slug}>
            <Link to={`/${edition.type}/${edition.slug}`} className={classNames('edition-container', { active: product.slug === edition.slug })} title={edition.name}>
              <div className="edition">
                <div className="edition-name">
                  { editionName }
                </div>
                {!presale &&
                  <div className="prices-container">
                    <span className={classNames('current-price', { active: product.slug === edition.slug })}>
                      <Price price={currentPrice} />
                    </span>
                    {edition.price[currencyCode] !== currentPrice[currencyCode] &&
                      <span className="full-price">
                        <Price price={edition.price} />
                      </span>
                    }
                  </div>
                }
              </div>
            </Link>
          </React.Fragment>
        );
      })}
    </div>
  );
}

ProductEditionSelector.propTypes = {
  product: PropTypes.shape({}),
  sortByName: PropTypes.bool,
};

ProductEditionSelector.defaultProps = {
  product: null,
  sortByName: false,
};

export default ProductEditionSelector;
